export default {
  name: 'SortingBlock',
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    current: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    handleScrollDown: function handleScrollDown() {
      this.$emit('scrollDown');
    }
  }
};